import * as React from 'react';

import {colors} from '../../colors/colors';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Source from './icon-source.svg';

type Props = {
    color?: string;
    size?: number;
};

function SvgComponent(props: Props) {
    const validProps = Object.assign({}, props);
    // @ts-expect-error
    delete validProps.styles;

    return <Source {...validProps} color={props.color || colors.greenDk} />;
}
SvgComponent.iconName = 'source';

export const SourceIcon = svgIconWrapper(SvgComponent);
